'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useCallback, useMemo } from 'react';

import {
  OperationArchivesContainer,
  SearchSchema,
} from '@/features/operation-archives';
import type { ArchiveTableRow } from '@/features/operation-archives';

import {
  ATTENDANCE_ARCHIVE_PACKAGE_OPTIONS,
  useAttendanceCoreArchives,
} from './-query';

export const Route = createFileRoute(
  '/_staff/attendance-core/_layout/archive/',
)({
  component: AttendanceCoreArchive,
  validateSearch: zodValidator(SearchSchema),
});

function AttendanceCoreArchive() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  const archivesQuery = useAttendanceCoreArchives({
    page: search.pageIndex + 1,
    pageSize: search.pageSize,
    textSearch: search.textSearch,
    operationPackageId: search.operationPackageId,
    anchorDateFrom: search.anchorDateFrom,
    anchorDateTo: search.anchorDateTo,
    orderBy: search.orderBy ?? 'finishedAt',
    orderDirection: search.orderDirection,
  });

  const packageOptionsQuery = useMemo(
    () => ({
      data: ATTENDANCE_ARCHIVE_PACKAGE_OPTIONS,
      isPending: false,
    }),
    [],
  );

  // モック段階のため遷移先はなし。将来オペレーションインスタンス詳細画面が
  // 実装されたらそちらへ navigate する。
  const handleRowClick = useCallback((_row: ArchiveTableRow) => {}, []);

  return (
    <OperationArchivesContainer
      searchParams={search}
      onNavigate={navigate}
      archivesQuery={archivesQuery}
      packageOptionsQuery={packageOptionsQuery}
      onRowClick={handleRowClick}
    />
  );
}
